import Utils from '../../utils/util';
import { getInstance } from './get';
import { updateTransformConfig } from './updateConfig';
import { fullscreenScale } from './fullscreenScale';

function zoomIn(point: MousePoint): void {
    let stageMatrix: MatrixInstance = getInstance();
    let $win: JQuery<Window> = $(window);

    stageMatrix.zoomIn(point);
    updateTransformConfig();
}

function zoomOut(point: MousePoint): void {
    let stageMatrix: MatrixInstance = getInstance();
    let $win: JQuery<Window> = $(window);

    stageMatrix.zoomOut(point);
    updateTransformConfig();
}

function zoomTo(scale: number, point: MousePoint): void {
    let stageMatrix: MatrixInstance = getInstance();
    let $win: JQuery<Window> = $(window);

    stageMatrix.zoomTo(scale, point);
    updateTransformConfig();
}

function zoomToStage(): void {
    let $win: JQuery<Window> = $(window);
    let scale: number = fullscreenScale();

    zoomTo(scale, {
        left: Utils.math($win.width(), 2, '/'),
        top: Utils.math($win.height(), 2, '/'),
    });
}

export {
    zoomIn,
    zoomOut,
    zoomTo,
    zoomToStage
};
